export default function SystemMessage () {
  const messageBar = document.querySelector('.mtt-system-message')
  if (!messageBar) return

  const closeBtn = messageBar.querySelector('.mtt-system-message__close')
  const messageHash = messageBar.getAttribute('data-message-hash')
  const cookieName = 'system_message_dismissed_' + messageHash

  closeBtn.addEventListener('click', () => {
    const date = new Date()
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000))
    document.cookie = cookieName + '=1; expires=' + date.toUTCString() + '; path=/'
    messageBar.remove()
  })
}
